import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select, Form, Tooltip } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";

const { Panel } = Collapse;

const PurchaseRequisitionSites = (userSelectedSiteList) => {
  console.log("userSelectedSiteList", userSelectedSiteList);
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);

  const { t } = useTranslation();
  const { id, prId} = useParams();
  const [stateWBS, setStateWBS] = useState([
    "Available Budget",
    "Estimated PR Value",
  ]);

  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [totalAmountPr, setTotalAmountPr] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const initialState = {
    company: CompanyID,
    category_tree: id,
    total_amount: null,
    purchase_requisition_details: [],
  };
  const [state, setState] = useState(initialState);

  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [subCategoryData, setSubCategoryData] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  useEffect(() => {
    getSubCategory();
    getCurrency();
    getUnitOfMeasurement();
    if (siteName.length === 0) {
      getSiteName();
    }
  }, [id, siteName]);

    useEffect(() => {
        if (userSelectedSiteList.userSelectedSiteList?.length !== 0) {
            setSiteName(userSelectedSiteList.userSelectedSiteList);
        }
    }, [userSelectedSiteList]);
    console.log('siteName10  ', siteName);
    
  useEffect(() => {
    const calculateTotalAmounts = () => {
      const amounts = state.purchase_requisition_details.map((detail) => {
        const matchedEstimation = estimatedValueFromApi.find(
          (est) => est.id === detail.material_type
        );

        if (
          matchedEstimation &&
          typeof detail.total_quantity === "number" &&
          typeof matchedEstimation.value === "number"
        ) {
          //console.log("details master", detail);
          return detail.total_quantity_by_kg * matchedEstimation.value;
        } else {
          return 0;
        }
      });
      const totalAmount = amounts.reduce((acc, curr) => acc + curr, 0);
      setTotalAmountPr(totalAmount);
    };

    setState((prevState) => ({
      ...prevState,
      total_amount: totalAmountPr,
    }));

    const calculateSiteWiseTotal = () => {
      const siteWiseTotals = {};

      state.purchase_requisition_details.forEach((item) => {
        item.site_wise.forEach((data) => {
          const { site_name, quantity } = data;
          if (siteWiseTotals[site_name]) {
            siteWiseTotals[site_name] += parseFloat(quantity) || 0;
          } else {
            siteWiseTotals[site_name] = parseFloat(quantity) || 0;
          }
        });
      });
      const siteWiseTotalArray = Object.keys(siteWiseTotals).map(
        (siteName) => ({
          siteName,
          total: siteWiseTotals[siteName],
        })
      );
    };

    const calculateSiteWiseTotalAmounts = () => {
      const siteWiseTotalAmounts = {};

      state.purchase_requisition_details.forEach((detail) => {
        detail.site_wise.forEach((site) => {
          const { site_name, quantity } = site;
          const matchedEstimation = estimatedValueFromApi.find(
            (est) => est.id === detail.material_type
          );

          if (matchedEstimation && site_name) {
            const total = matchedEstimation.value * quantity;
            if (siteWiseTotalAmounts[site_name]) {
              siteWiseTotalAmounts[site_name] += total;
            } else {
              siteWiseTotalAmounts[site_name] = total;
            }
          }
        });
      });
      setSiteWiseTotalAmount(siteWiseTotalAmounts);
    };

    calculateTotalAmounts();
    calculateSiteWiseTotal();
    calculateSiteWiseTotalAmounts();
  }, [
    state.purchase_requisition_details,
    estimatedValueFromApi,
    totalAmountPr,
  ]);

  console.log('subCategoryList', subCategoryList);
  

  const getSubCategory = async () => {
    try {
      let apiResponse;
      if(prId === null || prId === undefined){
      apiResponse = await getRequest(
        `company-material-code/1/get-pr-material-by-checked/`
      );

      setEstimatedValueFromApi((estimatedValueFromApi) => [
        ...estimatedValueFromApi,
        ...apiResponse.data.data.map((item) => ({
          id: item.company_material_code,
          value: item.estimated_price,
        })),
      ]);


      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
          const siteWise = siteName.map((site) => ({
            site_name: site.id,
            quantity: null,
          }));
          return {
            material_type: item.company_material_code,
            material_type_id: item.id,
            unit_of_measurement: item.unit_of_measurement,
            unit_of_measurement_name: item.unit_of_measurement_name,
            estimated_price: item.estimated_price,
            remark: null,
            total_quantity: 0,
            total_quantity_by_kg: 0,
            site_wise: siteWise,
          };
        });
        setState((prevState) => ({
          ...prevState,
          category_tree: 1,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category))
        );
        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
      } 
    }
    else{
      apiResponse = await getRequest(
        `purchase-requisition-by-material/${prId}/`
      );
      setEstimatedValueFromApi((estimatedValueFromApi) => [
        ...estimatedValueFromApi,
        ...apiResponse.data.data.purchase_requisition_details.map((item) => ({
          id: item.material_type_by_company,
          value: item.estimated_material_unit_price,
        })),
      ]);
      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.purchase_requisition_details.map((item) => {
          const siteWise = item.site_wise.map((site) => ({
            site_name: site.site_id,
            quantity: site.quantity, 
          }));
          return {
            material_type: item.material_type_name_by_company,
            material_type_id: item.material_type_by_company,
            unit_of_measurement: item.unit_of_measurement,
            unit_of_measurement_name: item.unit_of_measurement_name,
            total_quantity: item.total_quantity,
            total_quantity_by_kg: item.total_quantity_by_kg,
            site_wise: siteWise,
          };
        });
        setState((prevState) => ({
          ...prevState,
          category_tree: 1,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.purchase_requisition_details.map((item) => item.sub_category))
        );

        setSubCategoryList(uniqueSubCategories);

        apiResponse.data.data.purchase_requisition_details.map((itm) => {
          setSubCategoryData((prevState) => [...prevState, itm.sub_category]);
        });
        const transformedData = apiResponse.data.data.purchase_requisition_details.map(item => ({
          id: item.material_type_by_company,
          company: apiResponse.data.company_id, 
          company_name: apiResponse.data.company, 
          category_tree: apiResponse.data.category_tree,
          category_tree_name: apiResponse.data.category_tree_name,
          material_type: item.pr_details_id, 
          material_type_name: item.material_type_name_by_company,
          company_material_code: item.company_material_code || "", 
          smart_buyer_code: item.smart_buyer_code || "", 
          unit_of_measurement: item.unit_of_measurement,
          unit_of_measurement_name: item.unit_of_measurement_name,
          estimated_price: item.estimated_material_unit_price,
          sub_category: item.sub_category,
          gst_rate: item.gst_rate || "18.0", 
          is_checked: true,

          total_quantity: item.total_quantity,
          total_quantity_by_kg: item.total_quantity_by_kg,
          site_wise: item.site_wise.map(site => ({
            site_id: site.site_id,
            site_name: site.site_name,
            quantity: site.quantity
          }))
          
        }));
  
        setSubCategoryData(transformedData);


      } 
    }
    } catch (error) {
      // setLoading(false);
    }
  };

  const getUnitOfMeasurement = async (data) => {
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        // setPincodeList(response.data.results.data);
        const filteredData = response.data.results.data.filter(
          (item) => item.unit_of_measurement !== "KG"
        );
        setPincodeList(filteredData);
      }
    );
  };

  const getSiteName = async () => {
    //setLoading(true);

    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyID}/address-by-company/`
      );
      if (apiResponse.data.data) {
        if(userSelectedSiteList.userSelectedSiteList.length === 0){
          setSiteName(apiResponse.data.data);
        }
        const updatedState = { ...state };
        updatedState.purchase_requisition_details.forEach((detail) => {
          detail.site_wise.forEach((site, index) => {
            site.site_name = apiResponse.data.data[index]
              ? apiResponse.data.data[index].site.id
              : null;
          });
        });


        setState(updatedState);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
    } catch (error) {
      //setLoading(false);
    }
  };

  const subCategoryColumnsWBC = [
    {
      title: "WBS",
      dataIndex: "WBS",
      key: "WBS",
      render: (text, record, rowIndex) => <span>{stateWBS[rowIndex]}</span>,
    },
  ];

  const WBCsiteNameColumns = siteName.map((item, index) => ({
    title: item.site_name,
    dataIndex: `site_name_${index}`,
    key: `site_name_${index}`,
    render: (text, record, rowIndex) => (
      <>
        <Input
          addonBefore={currencySymbol}
          style={{ width: "100%" }}
          value={rowIndex ? siteWiseTotalAmount[item.id] : ""}
          readOnly
        />
      </>
    ),
    width: 170,
  }));

  const handleRemarkChange = (e, id, index) => {
      const { value } = e.target;
      setState((prevState) => {
          const newState = { ...prevState };
          newState.purchase_requisition_details =
              state.purchase_requisition_details.map((detail) => {
                  if (detail.material_type === id) {
                      detail.remark = value;
                  }
                  return detail;
              });
          return newState;
      });
  };
  const handleInputChange = (e, id, index) => {
    const { value } = e.target;

    setState((prevState) => {
      const newState = { ...prevState };
      newState.purchase_requisition_details =
        state.purchase_requisition_details.map((detail) => {
          if (detail.material_type === id) {
            detail.site_wise[index].quantity = value;
            detail.total_quantity = detail.site_wise.reduce(
              (acc, site) => acc + (parseFloat(site.quantity) || 0),
              0
            );
            detail.total_quantity_by_kg = detail.site_wise.reduce((acc, site) => {
                  // Check if site.quantity is not null, undefined, or an empty string
                if (detail.unit_of_measurement_name === "MT") {
                    return acc += site.quantity * 1000 || 0;
                } else if (detail.unit_of_measurement_name === "Bag") {
                    return acc += site.quantity * 50 || 0;
                } else {
                    return acc += site.quantity || 0;
                }
            }, 0);
          }
          return detail;
        });
      return newState;
    });
  };


  const filterItemsBySubCategory = (subCategory) => {
    return subCategoryData.filter((item) => item.sub_category === subCategory);

  };
  const handleUOMChange = (value, materialId, unitOfMeasurement) => {
    setState((prevState) => {
      const newState = { ...prevState };
      newState.purchase_requisition_details =
        prevState.purchase_requisition_details.map((item, index) => {
          if (item.material_type === materialId) {
            // console.log("item", item);
            // console.log("materialId", materialId);
              if (unitOfMeasurement === "MT") {
                  //totalKilogram += site.quantity * 1000 || 0;
                  return {
                      ...item,
                      unit_of_measurement: value,
                      unit_of_measurement_name: unitOfMeasurement,
                      total_quantity_by_kg: item.total_quantity * 1000
                  };
              } else if (unitOfMeasurement === "Bag") {
                  //totalKilogram += site.quantity * 50 || 0;
                  return {
                      ...item,
                      unit_of_measurement: value,
                      unit_of_measurement_name: unitOfMeasurement,
                      total_quantity_by_kg: item.total_quantity * 50
                  };
              } else {
                  return {
                      ...item,
                      unit_of_measurement: value,
                      unit_of_measurement_name: unitOfMeasurement,
                      total_quantity_by_kg: item.total_quantity
                  };
              }
          }
          return item;
        });
      return newState;
    });
  };
  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };
  const wbsBudget = [
    {
      title: "Sr",
      dataIndex: "Sr",
      key: "4",
      width: 80,
      render: (text, record, index) => index + 1,
    },
    ...subCategoryColumnsWBC,
    ...WBCsiteNameColumns,
    {
      title: "WBS Budget",
      dataIndex: "total_amount",
      key: "total_amount",
      width: 150,
      render: (text, record, index) => {
        if (index === 1) {
          const totalQuantity = totalAmountPr ? totalAmountPr : 0; 
          return (
            <Input
              addonBefore={currencySymbol}
              value={`${totalQuantity}`} 
            />
          );
        } else {
          return null; 
        }
      },
    },
    {
      title: "",
      dataIndex: "unit_of_measurement",
      key: "unit_of_measurement",
      width: 150,
    },
  ];

  const theadWbsBudget = <Table columns={wbsBudget} />;
  const subCategoryTables = subCategoryList.map((subCategory, index) => {
    const subCategoryItems = filterItemsBySubCategory(subCategory);
    const subCategoryColumns = [
      {
        title: index + 1,
        dataIndex: "Sr No",
        key: "1",
        width: 80,
        render: (text, record, ind) => {
          return `${index + 1}.${ind + 1}`;
        },
      },
      {
        title: subCategory,
        dataIndex: "company_material_code.company_material_name",
        key: "company_material_name",
        render: (text, record) => {
          return record.material_type_name;
        },
      },
      ...(index === 0
        ? siteName.map((site, index) => ({
          title: site.site_name, 
          dataIndex: `site_name_${index}`, 
          key: `${site.site_name}_${subCategory}_${index}`, 
          width: 170,
          render: (text, record) => {
            return (
              <Input
                type="text"
                      min={0}
                      maxLength={5}
                placeholder="Enter Qty"
                style={{ width: "100%" }}
                onChange={(e) => handleInputChange(e, record.company_material_code, index)}
              />
            )
          },
        }))
        : siteName.map((site, index) => ({
          key: `${site.site_name}_${subCategory}_${index}`, 
          width: 170,
          render: (text, record) => {
            return (
            <Input
              type="text"
                      min={0}
                      maxLength={5}
              placeholder="Enter Qty"
              style={{ width: "100%" }}
              value={record[`quantity_${index}`]} 
              onChange={(e) => handleInputChange(e, record.company_material_code, index)}
            />
          )},
        }))),
      {
        title: index === 0 ? (
          <Tooltip
              color="#094E8F"
              placement="top"
              title={<span style={{ color: "#fff" }}>Preferred Unit of measurement means Your company buys material generally in this unit of measurement</span>}
          >
              Preferred UoM.
          </Tooltip>
      ) : "",
        dataIndex: "unit_of_measurement",
        key: "unit_of_measurement",
        width: 150,
        render: (text, record, rowIndex) => {
          const defaultOption = pincodeList.find(
            (option) => option.unit_of_measurement === "MT"
          );
          const defaultValue = defaultOption ? defaultOption.id : 1;
          return (
            <Select
              style={{ width: "100%" }}
              defaultValue={defaultValue}
              onChange={(value) => {
                  const selectedOption = pincodeList.find(option => option.id === value);
                  handleUOMChange(value, record.company_material_code, selectedOption.unit_of_measurement);
              }}
              //onChange={(value) => handleUOMChange(value, record.company_material_code)}
            >
              {pincodeList.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.unit_of_measurement}
                </Option>
              ))}
            </Select>
          );
        },
      },
        {
            title: "Total Quantity",
            dataIndex: "total_quantity",
            key: "total_quantity",
            width: 120,
            align:'right',
            render: (text, record) => {

                const correspondingRecord = state.purchase_requisition_details.find(
                    (item) => item.material_type === record.company_material_code
                );
                let totalQuantity = 0;
                if (correspondingRecord) {
                    correspondingRecord.site_wise.forEach((site) => {
                        totalQuantity += parseFloat(site.quantity) || 0;
                    });
                }
                return (
                    <span>{totalQuantity?.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</span>
                );
            }
        },
      {
            title: (
              <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={<span style={{ color: "#fff" }}>Quantity In KG</span>}
              >
                  Qty. In KG
              </Tooltip>
          ),
            width: 120,
            dataIndex: "total_quantity_by_kg",
            key: "total_quantity_by_kg",
            align:'right',
            render: (text, record) => {
                const correspondingRecord = state.purchase_requisition_details.find(
                    (item) => item.material_type === record.company_material_code
                );
                let totalKilogram = 0;
                if (correspondingRecord) {
                    correspondingRecord.site_wise.forEach((site) => {
                        if (correspondingRecord.unit_of_measurement_name === "MT") {
                            totalKilogram += site.quantity * 1000 || 0;
                        } else if (correspondingRecord.unit_of_measurement_name === "Bag") {
                            totalKilogram += site.quantity * 50 || 0;
                        } else {
                            totalKilogram += parseFloat(site.quantity) || 0;
                        }
                    });
                }
                return (
                    <span>{totalKilogram ? totalKilogram.toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0}</span>
                );
            }
        },
        {
            title: (
              <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
              >
                  Est. Amount
              </Tooltip>
          ),
            dataIndex: "siteLocations",
            width: 160,
            align:'right',
            render: (text, record) => {
                const correspondingRecord = state.purchase_requisition_details.find(
                    (item) => item.material_type === record.company_material_code
                );
                let totalAmount = 0;
                if (correspondingRecord) {
                    correspondingRecord.site_wise.forEach((site) => {
                        totalAmount += parseFloat(site.quantity) || 0;
                    });
                }
                return (
                    <span>₹ {correspondingRecord?.total_quantity_by_kg ? (correspondingRecord?.total_quantity_by_kg * correspondingRecord?.estimated_price).toLocaleString('en-IN', { maximumFractionDigits: 0 }) : 0} </span>
                );
            },
        },
      {
            title: "Remarks",
            dataIndex: "company_material_code.company_material_name",
            key: "company_material_name",
            width: 170,
            render: (text, record) => {
                return (
                    <Input
                        type="text"
                        placeholder="Enter Remarks"
                        style={{ width: "100%" }}
                        onChange={(e) => handleRemarkChange(e, record.company_material_code, index)}
                    />
                )
            },
        },
    ];
    const theadColumns = <Table columns={subCategoryColumns} />;
    return (
      <>
        <Collapse defaultActiveKey={["4"]} className="collapsescrl">
          <Panel header={theadColumns} key="4">
            <Table
              key={subCategory}
              columns={subCategoryColumns}
              dataSource={subCategoryItems}
              pagination={false}
            />
          </Panel>
        </Collapse>
      </>
    );
  });

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      const payload1 = {
        company: state.company,
        category_tree: state.category_tree,
        total_amount: state.total_amount, 
        purchase_requisition_details: state.purchase_requisition_details.map(
          (detail) => {
            return {
              material_type_by_company: detail.material_type_id,
              unit_of_measurement: detail.unit_of_measurement,
              remark: detail.remark,
              total_quantity: detail.total_quantity,
              total_quantity_by_kg: detail.total_quantity_by_kg,
              site_wise: detail.site_wise.map((site) => {
                return {
                  site_name: site.site_name,
                  quantity: site.quantity, 
                };
              }),
            };
          }
        ),
      };

      const payload2 = {
        company: state.company,
        category_tree: state.category_tree,
        total_amount: state.total_amount, 
        purchase_requisition_details: state.purchase_requisition_details.map(
          (detail) => {
            return {
              material_type_by_company: detail.material_type,
              unit_of_measurement: detail.unit_of_measurement,
              remark: detail.remark,
              total_quantity: detail.total_quantity,
              total_quantity_by_kg: detail.total_quantity_by_kg,
              site_wise: detail.site_wise.map((site) => {
                return {
                  site_name: site.site_name,
                  quantity: site.quantity, 
                };
              }),
            };
          }
        ),
      };

      let response;
      if (!prId) {
        response = await postRequest("purchase-requisition-by-material/", payload1);
      } else {
        response = await postRequest("purchase-requisition-by-material/", payload2);
      }

      if (response.data.success) {
        SuccessNotificationMsg(response.data.message);
        setState(initialState);
        navigate("/purchase-requisition-history");
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleDraft = async () => {
    try {
      setBtnLoading2(true);

      const payload = {
        company: state.company,
        category_tree: state.category_tree,
        total_amount: state.total_amount,
        purchase_requisition_details: state.purchase_requisition_details.map(
          (detail) => {
            return {
              material_type_by_company: detail.material_type_id, 
              unit_of_measurement: detail.unit_of_measurement, 
              total_quantity: detail.total_quantity, 

              site_wise: detail.site_wise.map((site) => {
                return {
                  site_name: site.site_name, 
                  quantity: site.quantity, 
                };
              }),
            };
          }
        ),
      };

      let response;
      if (CompanyID !== null) {
        response = await postRequest(
          "purchase-requisition-by-material/draft-purchase-requisition-material-wise/",
          payload
        );
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyID === null
            ? t("purchase_requisition_draft_successfully")
            : t("purchase_requisition_draft_updated_successfully")
        );

        setState(initialState);
        navigate("/purchase-requisition-history");
        setBtnLoading2(false);
      }
    } catch (error) {
      setBtnLoading2(false);
    }
  };
  const handleDisable = () => {
    const { purchase_requisition_details } = state;

    for (let detail of purchase_requisition_details) {
      for (let site of detail.site_wise) {
        if (site.quantity === null) {
          return true;
        }
      }
    }
    return false;
  };

  useEffect(() => {
    const { purchase_requisition_details } = state;

    for (let detail of purchase_requisition_details) {
      for (let site of detail.site_wise) {
        if (site.quantity === null || site.quantity === "") {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      }
    }
  }, [state.purchase_requisition_details]);

  const colors = ["#094E8F"];
  return (
    <>

      {subCategoryTables}

      {/*<Collapse defaultActiveKey={["1"]}>*/}
        {/*<Panel header={theadWbsBudget} key="4">*/}
          {/*<Table*/}
            {/*columns={wbsBudget}*/}
            {/*dataSource={stateWBS}*/}
            {/*pagination={false}*/}
          {/*/>*/}
        {/*</Panel>*/}
      {/*</Collapse>*/}
      <Form>
        <div className="btnwrp" style={{ paddingTop: "16px" }}>
          <ButtonField
            className="CancelGradiantBtn"
            type="primary"
            htmlType="Cancel"
            label="Cancel"
            onClick={() => navigate("/dashboard")}

          />
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            htmlType="Send PR for Approval"
            label="Send PR for Approval"
            loading={btnLoading}
            onClick={handleSubmit}
            disabled={disabled}
          />
        </div>
      </Form>

    </>
  );
};
export default PurchaseRequisitionSites;
